<template>
  <div :class="['pagina-titulo-container', 'no-print', { 'pagina-titulo-sticky': sticky }]">
    <div class="pagina-titulo-wrapper">
      <div class="pagina-titulo">
        <div>
          <h1>
            {{ titulo.toUpperCase() }}
          </h1>
          <h2>
            {{ subTitulo }}
          </h2>
        </div>
        <div class="pagina-titulo-primeiro-slot">
          <slot name="primeiroSlot" />
        </div>
      </div>
      <div class="pagina-titulo-slot">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginaTitulo",
  props: {
    titulo: String,
    subTitulo: String,
    sticky: Boolean
  }
};
</script>

<style lang="scss" scoped>
.pagina-titulo-container {
  width: 100%;
  background: linear-gradient(to right, var(--azul4), var(--branco));
  display: flex;
  justify-content: center;
  // border-bottom: 1px solid var(--cinza02);
  box-shadow: 0 2px 4px var(--sombra0);
  // border-top: 1px solid var(--azul5);
}
.pagina-titulo-sticky {
  position: sticky;
  top: -1px;
  z-index: 1;
}
.pagina-titulo-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1155px;
  // background: green;
  padding: 0 15px;
  margin: 10px 0;
  font-family: "Roboto Condensed";
  h1 {
    color: var(--branco);
    font-weight: bold;
    font-size: 30px;
    margin: 0;
  }
  h2 {
    font-weight: normal;
    color: var(--cinza02);
    font-size: 13px;
    float: left;
    width: 100%;
    text-transform: initial;
    margin: 0;
  }
}
.pagina-titulo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagina-titulo-slot {
  display: flex;
}
.pagina-titulo-primeiro-slot {
  margin: 0 15px;
}
</style>
